import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const AngleRightIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "angleRightIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M5.02741 20.001C5.24955 20.001 5.4717 19.9162 5.64127 19.7466L12.773 12.6148C13.1122 12.2757 13.1122 11.7263 12.773 11.3871L5.64127 4.25534C5.30212 3.91619 4.7527 3.91619 4.41354 4.25534C4.07439 4.59449 4.07439 5.14392 4.41354 5.48307L10.9314 12.001L4.41354 18.5189C4.07439 18.858 4.07439 19.4075 4.41354 19.7466C4.58311 19.9162 4.80527 20.001 5.02741 20.001Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.8404 20.001C12.0625 20.001 12.2847 19.9162 12.4543 19.7466L19.586 12.6148C19.9252 12.2757 19.9252 11.7263 19.586 11.3871L12.4543 4.25534C12.1151 3.91619 11.5657 3.91619 11.2265 4.25534C10.8874 4.59449 10.8874 5.14392 11.2265 5.48307L17.7444 12.001L11.2265 18.5189C10.8874 18.858 10.8874 19.4075 11.2265 19.7466C11.3961 19.9162 11.6183 20.001 11.8404 20.001Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default AngleRightIcon;
